import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AuthProvider } from "./AuthContext";
import { AuthEmpleadoProvider } from "./context/AuthEmpleadoContext";


import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <AuthEmpleadoProvider>
    <BrowserRouter basename="/portal">
      <App />
    </BrowserRouter>
    </AuthEmpleadoProvider>
  </AuthProvider>,

);

reportWebVitals();